import Service from "../Service";

const resource = "numerationdocumentlegal/";

export default {
    save(nud, requestID) {
        return Service.post(resource + "save", nud, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
};